import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _css, _css2, _span, _css3, _css6, _input;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes } from '@emotion/react';
import { defaultEmojiHeight } from '../../util/constants';
import { akEmojiSelectedBackgroundColor } from '../../util/shared-styles';
import { B100, N20, N200, N20A, N300, N400, N900, R300, R400 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
import { fontFallback } from '@atlaskit/theme/typography';
export var commonSelectedStyles = 'emoji-common-selected';
export var selectOnHoverStyles = 'emoji-common-select-on-hover';
export var emojiSprite = 'emoji-common-emoji-sprite';
export var emojiNodeStyles = 'emoji-common-node';
export var emojiImage = 'emoji-common-emoji-image';
export var emojiDeleteButton = 'emoji-common-deleteButton';
export var emojiMainStyle = 'emoji-common-main-styles';
export var deletableEmoji = 'emoji-common-deletable';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var deleteButton = css({
  // hide by default
  visibility: 'hidden',
  display: 'flex',
  position: 'absolute',
  top: "var(--ds-space-negative-100, -8px)",
  right: "var(--ds-space-negative-100, -8px)",
  zIndex: 1,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '& span': {
    lineHeight: 0
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiToneSelectorContainer = css({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '11px 10px 12px 0'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiImageContainer = css((_css = {
  borderRadius: "var(--ds-border-radius-100, 3px)",
  backgroundColor: 'transparent',
  display: 'inline-block',
  verticalAlign: 'middle',
  // Ensure along with vertical align middle, we don't increase the line height for p and some
  // headings. Smaller headings get a slight increase in height, cannot add more negative margin
  // as a "selected" emoji (e.g. in the editor) will not look good.
  margin: '-1px 0',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  img: {
    display: 'block'
  }
}, _defineProperty(_css, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundColor: akEmojiSelectedBackgroundColor
}), _defineProperty(_css, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover .").concat(emojiDeleteButton), {
  // show delete button on hover
  visibility: 'visible'
}), _defineProperty(_css, "&.".concat(deletableEmoji), {
  position: 'relative'
}), _defineProperty(_css, "&.".concat(deletableEmoji, ":focus-within .").concat(emojiDeleteButton), {
  visibility: 'visible'
}), _defineProperty(_css, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiSpriteContainer = css((_css2 = {
  display: 'inline-block',
  // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
  margin: '-1px 0'
}, _defineProperty(_css2, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundColor: akEmojiSelectedBackgroundColor
}), _defineProperty(_css2, ".".concat(emojiSprite), {
  background: 'transparent no-repeat',
  display: 'inline-block',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  minHeight: "".concat(defaultEmojiHeight, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  minWidth: "".concat(defaultEmojiHeight, "px"),
  verticalAlign: 'middle'
}), _defineProperty(_css2, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css2));
export var placeholder = 'emoji-common-placeholder';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var placeholderContainer = css({
  position: 'relative',
  margin: '-1px 0',
  display: 'inline-block',
  background: "var(--ds-border, #f7f7f7)",
  borderRadius: "var(--ds-border-radius-100, 3px)",
  overflow: 'hidden',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  textAlign: 'center'
});
var easeSweep = keyframes({
  from: {
    transform: 'translateX(-100%)'
  },
  to: {
    transform: 'translateX(100%)'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var placeholderContainerAnimated = css({
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    background: "var(--ds-background-neutral, ".concat(N20A, ")"),
    height: '100%',
    width: '100%',
    animation: "".concat(easeSweep, " 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var hidden = css({
  opacity: 0,
  visibility: 'hidden',
  display: 'none'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiButton = css((_css3 = {
  backgroundColor: 'transparent',
  border: '0',
  borderRadius: "var(--ds-border-radius-100, 3px)",
  cursor: 'pointer',
  padding: 0,
  position: 'relative',
  display: 'inline-block'
}, _defineProperty(_css3, '&::-moz-focus-inner', {
  border: '0 none',
  padding: 0
}), _defineProperty(_css3, '&>span', (_span = {
  padding: "var(--ds-space-075, 6px)"
}, _defineProperty(_span, "&>.".concat(emojiSprite), {
  height: '24px',
  width: '24px'
}), _defineProperty(_span, "&>img", {
  height: '24px',
  width: '24px'
}), _span)), _defineProperty(_css3, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css3));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiRadio = css({
  opacity: 0,
  position: 'absolute',
  top: '-10px',
  left: '-10px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '+span': {
    borderRadius: "var(--ds-border-radius-100, 3px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:focus + span': {
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
    transitionDuration: '0s, 0.2s',
    outline: 'none'
  }
});

// Emoji Preview
export var emojiPickerAddEmoji = 'emoji-picker-add-emoji';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var previewText = css({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  marginTop: "var(--ds-space-negative-025, -2px)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginLeft: '10px',
  maxWidth: '285px',
  width: '285px' /* IE */,
  flexGrow: 1,
  flexShrink: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiName = css(_defineProperty({
  display: 'block',
  color: "var(--ds-text, ".concat(N900, ")"),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, '&:first-letter', {
  textTransform: 'uppercase'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiShortName = css(_defineProperty({
  display: 'block',
  color: "var(--ds-text-subtle, ".concat(N200, ")"),
  fontSize: '12px',
  lineHeight: 1,
  marginBottom: "var(--ds-space-negative-025, -2px)",
  overflow: 'hidden',
  paddingBottom: "var(--ds-space-025, 2px)",
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, '&:first-of-type', {
  color: "var(--ds-text, ".concat(N900, ")"),
  fontSize: '14px'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var preview = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  padding: '10px',
  height: '32px',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var previewImg = css((_css6 = {
  display: 'inline-block',
  flex: 'initial',
  width: '32px'
}, _defineProperty(_css6, "& .".concat(emojiSprite, ", span[role=\"img\"]"), {
  width: '32px',
  height: '32px',
  padding: 0,
  maxHeight: 'inherit'
}), _defineProperty(_css6, "& span[role=\"img\"] > img", {
  position: 'relative',
  left: '50%',
  top: '50%',
  transform: 'translateX(-50%) translateY(-50%)',
  maxHeight: '32px',
  maxWidth: '32px',
  padding: 0,
  display: 'block'
}), _css6));

// Scrollable

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiScrollable = css({
  border: "1px solid ".concat("var(--ds-border, #fff)"),
  borderRadius: "var(--ds-border-radius-100, 3px)",
  display: 'block',
  margin: '0',
  overflowX: 'hidden',
  overflowY: 'auto',
  padding: '0'
});

// EmojiUpload

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiUpload = css({
  height: '78px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiUploadTop = css({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingBottom: '7px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  fontSize: '12px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadChooseFileMessage = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&&': {
    color: "var(--ds-text-subtle, ".concat(N300, ")")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var closeEmojiUploadButton = css({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiUploadBottom = css({
  fontSize: '11px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadChooseFileRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingBottom: '7px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadChooseFileEmojiName = css({
  flex: '1 1 auto',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginRight: '5px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  input: (_input = {
    background: 'transparent',
    border: 0,
    outline: 'none'
  }, _defineProperty(_input, '&:invalid', {
    boxShadow: 'none'
  }), _defineProperty(_input, '&::-ms-clear', {
    display: 'none'
  }), _input)
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadChooseFileBrowse = css({
  flex: '0 0 auto'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadPreviewFooter = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  padding: '10px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadPreview = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: "var(--ds-background-neutral, ".concat(N20, ")"),
  borderRadius: "var(--ds-border-radius-100, 3px)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  padding: '10px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadPreviewText = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  h5: {
    color: "var(--ds-text-subtle, ".concat(N300, ")"),
    paddingBottom: "var(--ds-space-050, 4px)",
    fontSize: '12px'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  img: {
    maxHeight: '20px',
    maxWidth: '50px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var bigEmojiPreview = css({
  paddingLeft: "var(--ds-space-050, 4px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  img: {
    maxHeight: '40px',
    maxWidth: '100px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var uploadAddRow = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingTop: '10px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var addCustomEmoji = css({
  alignSelf: 'center',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginLeft: '10px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginBottom: '10px'
});

// Emoji Delete preview

export var submitDelete = 'emoji-submit-delete';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var deletePreview = css({
  height: '100px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var deleteText = css({
  height: '64px',
  fontSize: '12px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&:first-of-type': {
    color: "var(--ds-text-subtle, ".concat(N300, ")"),
    lineHeight: '16px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var headingH5 = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&&': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: "var(--ds-font-body-UNSAFE_small, ".concat(fontFallback.body.UNSAFE_small, ")"),
    fontWeight: "var(--ds-font-weight-semibold, 600)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var requiredSymbol = css({
  paddingLeft: "var(--ds-space-025, 2px)",
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  fontFamily: getFontFamily()
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var previewButtonGroup = css({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var deleteFooter = css(_defineProperty({
  display: 'flex',
  height: '40px',
  alignItems: 'center',
  justifyContent: 'space-between',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body, ".concat(fontFallback.body.medium, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  img: {
    maxHeight: '32px',
    maxWidth: '72px'
  }
}, ".".concat(submitDelete), {
  width: '84px',
  fontWeight: "var(--ds-font-weight-bold, bold)",
  marginRight: "var(--ds-space-050, 4px)"
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiDeleteErrorMessage = css({
  display: 'flex',
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiChooseFileErrorMessage = css({
  display: 'flex',
  color: "var(--ds-text-danger, ".concat(R300, ")"),
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingRight: '10px',
  justifyContent: 'flex-start'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiPreviewErrorMessage = css({
  display: 'inline-flex',
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingRight: '10px',
  justifyContent: 'flex-end',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var addCustomEmojiButton = css({
  maxWidth: '285px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var buttonSpinner = css({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginRight: '10px',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginLeft: '10px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiActionsWrapper = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var tooltipShortcutStyle = css({
  borderRadius: '3px',
  backgroundColor: "var(--ds-background-inverse-subtle, ".concat(N400, ")"),
  padding: "0 ".concat("var(--ds-space-025, 2px)"),
  /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */
  /* stylelint-disable-next-line */
  label: 'tooltip-shortcut'
});